import Popup from '@root/core/components/Popup';
import {
  OrderStatus,
  OrderStatusText,
  ReturnStatus,
  ReturnStatusLabel,
  WarehouseReturnDisposalStatusLabel,
  WarehouseReturnStatus,
  WarehouseReturnStatusLabel
} from '@root/modules/Sellers/Shipping/enum';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import commentService from '@root/core/components/CommentTabs/commentService';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Form, FormInstance, Spin } from 'antd';
import moment from 'moment';
import { memo, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../../../../../styles/abstracts/_variables.scss';
import '../../../../../styles/pages/seller/_return-detailOrder.scss';
import InfoProReturn from '../../components/InfoProduct';
import Recipient from '../../components/Recipient/Recipient';
import Product from '../../components/ReturnDetail/Product';
import CommentTabsComponent from '@root/core/components/CommentTabs';
import {
  Comment,
  CommentGroup,
  CommentList,
  CommentSide,
  CommentStatus,
  CommentTabs,
  CommentType,
  CreateComment
} from '@root/core/components/CommentTabs/interface';

interface Props {
  recipient: any;
  productComment: any;
  productOrder: any;
  refetch?: any;
  screenName?:
    | 'ReturnTrackingDetail'
    | 'ReturnDisposalDetail'
    | 'ReturnRequestDetail';
  hiddenModifyDelete?: Boolean;
}

const ReturnDetailOrder = ({
  recipient,
  productComment,
  productOrder,
  refetch,
  screenName,
  hiddenModifyDelete
}: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const [openSave, setOpenSave] = useState(false);
  const [isWarehouseRequestModify, setIsWarehouseRequestModify] =
    useState(false);
  const [returnData, setReturnData] = useState<FormInstance>();
  const [commentList, setCommentList] = useState<CommentList>();
  const [tabs, setTabs] = useState<CommentTabs[]>([]);
  const [disableCommentTab, setDisableCommentTab] = useState(false);
  const history = useHistory();

  // const columns: ColumnsType<DataType> = [
  //   {
  //     title: 'Update Date',
  //     dataIndex: 'updated_at',
  //     width: '20%'
  //   },
  //   {
  //     title: 'Courier',
  //     dataIndex: 'courier'
  //   },
  //   {
  //     title: 'Tracking Number',
  //     dataIndex: 'trackingNumber'
  //   },
  //   {
  //     title: 'Status',
  //     dataIndex: 'status'
  //   }
  // ];

  const defaultValueDataOrder = useMemo(() => {
    return {
      trackingNumber: recipient ? recipient?.trackingNumber : '',
      status: recipient ? recipient?.warehouseReturnStatus : '',
      updated_at: recipient?.warehouseUpdateDate
        ? moment(recipient?.warehouseUpdateDate).utc()
        : null,
      courier: recipient ? recipient?.courier : ''
    };
  }, [recipient]);

  useEffect(() => {
    form.setFieldsValue(defaultValueDataOrder);
  }, [form, defaultValueDataOrder]);

  // const dataSource = (): DataType[] => {
  //   return [
  //     {
  //       key: '1',
  //       updated_at: (
  //         <Form.Item>
  //           <Form.Item name={'updated_at'}>
  //             <DatePicker
  //               style={{ width: '100%' }}
  //               className="inputRadious"
  //               disabled={true}
  //               format={'YYYY.MM.DD hh:mm:ss a'}
  //               placeholder="YYYY.MM.DD 00:00:00"
  //             />
  //           </Form.Item>
  //         </Form.Item>
  //       ),
  //       courier: (
  //         <Form.Item
  //           name={['courier']}
  //           rules={[
  //             {
  //               pattern: new RegExp(/^[a-zA-Z\s]*$/),
  //               message: 'Only English can be entered'
  //             }
  //           ]}
  //         >
  //           <Input className="inputRadious" disabled={true} />
  //         </Form.Item>
  //       ),
  //       trackingNumber: (
  //         <Form.Item
  //           name={['trackingNumber']}
  //           rules={[
  //             {
  //               pattern: new RegExp(/^[a-zA-Z0-9\s]*$/),
  //               message: 'Only English can be entered'
  //             }
  //           ]}
  //         >
  //           <Input className="inputRadious" disabled={true} />
  //         </Form.Item>
  //       ),
  //       status: (
  //         <Form.Item
  //           name={['status']}
  //           rules={[
  //             {
  //               required: true,
  //               message: 'Input status!'
  //             }
  //           ]}
  //         >
  //           <Select
  //             className="quantitySelect"
  //             disabled={true}
  //             // onChange={onChangeStatus}
  //           >
  //             <Option value="Inprogress">Inprogress</Option>
  //             <Option value="Complete">Complete</Option>
  //           </Select>
  //         </Form.Item>
  //       )
  //     }
  //   ];
  // };

  const removeRequest = async () => {
    setLoading(true);
    setOpenRemove(false);
    await ReturnServices.removeReturn(recipient.id);
    history.push(
      recipient.processType === 'return'
        ? '/admin/seller/shipping/return-request'
        : '/admin/seller/shipping/return-disposal'
    );
  };

  const recipientOnChange = (data: FormInstance) => {
    setReturnData(data);
  };

  const saveRequest = async () => {
    setLoading(true);
    setOpenSave(false);
    if (returnData) {
      const body = returnData.getFieldsValue();
      await ReturnServices.updateReturn(recipient.id, {
        ...body,
        comment: body.sellerComment,
        detailReturnAddress: body.detailAddress,
        orderProducts: productOrder
      });
    }
    await refetch();
    setCanEdit(false);
    setLoading(false);
  };

  const sellerReasonOptions = [
    {
      label: '반환요청',
      value: 1
    },
    {
      label: '폐기요청',
      value: 2
    },
    {
      label: '재고전환',
      value: 3
    }
  ];

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
      setLoading(true);
    }
    let comments = await commentService.getComments({
      group: CommentGroup.RETURN_DETAIL,
      itemId: recipient.id
    });

    if (
      screenName === 'ReturnTrackingDetail' ||
      screenName === 'ReturnRequestDetail'
    ) {
      comments.data = comments.data.map((c: Comment) => {
        if (c.side === CommentSide.WAREHOUSE && c.type === CommentType.COMMON) {
          return {
            ...c,
            type: CommentType.INSPECTION
          };
        } else {
          return c;
        }
      });
    }

    setDisableCommentTab(
      comments.data.filter((c: Comment) => c.side === CommentSide.WAREHOUSE)
        .length === 0
    );
    setCommentList(comments);

    const isModifyApprovedFromWarehouse =
      comments.data.filter((c: Comment) => c.side === CommentSide.WAREHOUSE)
        .length > 0;
    setIsWarehouseRequestModify(isModifyApprovedFromWarehouse);

    if (
      screenName === 'ReturnTrackingDetail' ||
      screenName === 'ReturnDisposalDetail'
    ) {
      setTabs([]);
    } else if (
      recipient?.returnStatus === ReturnStatus.Request ||
      recipient?.returnStatus === ReturnStatus.Inprogress
    ) {
      setTabs([
        {
          title: 'Comment',
          type: CommentType.COMMON,
          description: 'Comment from Customer :'
        }
      ]);
    } else {
      setTabs([
        {
          title: 'Comment',
          type: CommentType.COMMON,
          description: 'Comment from Customer :'
        },
        {
          title: '상태 변경 요청',
          description: 'Reasons for modification from customer :',
          type: CommentType.REQUEST_MODIFY,
          options: sellerReasonOptions
        }
      ]);
    }

    if (screenName === 'ReturnRequestDetail') {
      const requestChangeIsApproved = comments.data.find(
        (c: Comment) =>
          c.side === CommentSide.SELLER &&
          c.type === CommentType.REQUEST_MODIFY &&
          c.status === CommentStatus.APPROVE
      );
      if (requestChangeIsApproved) {
        setTabs([]);
      }
    }

    if (showLoading) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (recipient.id) {
      getCommentList();
    }
  }, [recipient.id]);

  const onSendComment = async (body: CreateComment, id?: number) => {
    setLoading(true);
    // send comment
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
    setLoading(false);
  };

  return (
    <div className="returnDetailOrder">
      <Spin spinning={loading}>
        <p style={{ margin: '0px', padding: '20px' }}>
          Update Date:
          {formatDateTime(recipient?.updated_at)}
          {recipient?.returnStatus === ReturnStatus.Request &&
          !hiddenModifyDelete &&
          !isWarehouseRequestModify ? (
            <div className="right">
              {canEdit ? (
                <>
                  <span
                    className="span-btn"
                    onClick={async () => {
                      if (returnData) {
                        await returnData.validateFields();
                      }
                      setOpenSave(true);
                    }}
                  >
                    저장하기
                  </span>
                </>
              ) : (
                <>
                  <span className="span-btn" onClick={() => setCanEdit(true)}>
                    수정하기
                  </span>
                  <span style={{ margin: '0 10px' }}>ㅣ</span>
                  <span
                    className="span-btn"
                    onClick={() => setOpenRemove(true)}
                  >
                    삭제하기
                  </span>
                </>
              )}
            </div>
          ) : null}
          {screenName === 'ReturnTrackingDetail' ? (
            <>
              <Button
                className="renueProduct"
                style={{ display: 'inline', float: 'right' }}
              >
                {OrderStatusText[productComment.status as OrderStatus]}
              </Button>
            </>
          ) : null}
        </p>

        <InfoProReturn
          orderNumber={productComment.orderNumber}
          buyerName={productComment.buyerName}
          recipientName={productComment.recipientName}
          orderDate={formatDateTime(productComment.orderDate)}
          buyerEmail={productComment.buyerEmail}
          shippingAddress={productComment.detailAddress}
          detailAddress={productComment.detailAddress}
          detailAddress2={productComment.detailAddress2}
          saleChannel={productComment.saleChannel}
          recipientPhone={productComment.recipientPhone}
          street={productComment.shippingAddress}
          city={productComment.city}
          state={productComment.state}
          postalCode={productComment.postalCode}
          country={productComment.country}
        />

        <div
          style={{
            padding: '20px 20px 0px 20px',
            borderBottom: '1px solid #ebecef'
          }}
        >
          {productOrder.map((item: any) => (
            <Product
              productName={item.productName}
              sku={item.sku}
              eanUpc={item.eanUpc}
              quantity={item.quantity}
              enableQuantity={canEdit}
              onchange1={(e) => {
                item.quantity = e;
              }}
            />
          ))}
        </div>

        <div style={{ padding: '25px' }}>
          <Recipient
            entityId={recipient.id}
            recipientName={recipient.recipientName}
            recipientPhone={recipient.recipientPhone}
            returnAddress={recipient.detailReturnAddress}
            sellerComment={recipient.comment}
            detailReturnAddress={recipient.detailReturnAddress}
            postalCode={recipient.postalCode}
            country={recipient.country}
            detailReturnAddress2={recipient.detailReturnAddress2}
            state={recipient.state}
            city={recipient.city}
            returnReason={recipient.returnReason}
            statusReturn={
              ReturnStatusLabel[recipient.returnStatus as ReturnStatus]
            }
            warehouseReturnStatus={
              screenName === 'ReturnDisposalDetail'
                ? WarehouseReturnDisposalStatusLabel[
                    recipient.warehouseReturnStatus as WarehouseReturnStatus
                  ]
                : WarehouseReturnStatusLabel[
                    recipient.warehouseReturnStatus as WarehouseReturnStatus
                  ]
            }
            notQuan
            canEdit={canEdit}
            canUpdate
            onChange={recipientOnChange}
            screenName={screenName}
          />
        </div>
        {/* <Form
          form={form}
          style={{ margin: 'auto' }}
          initialValues={{
            trackingNumber: defaultValueDataOrder.trackingNumber,
            status: defaultValueDataOrder.status,
            updated_at: defaultValueDataOrder.updated_at
              ? defaultValueDataOrder.updated_at
              : '',
            courier: defaultValueDataOrder.courier
          }}
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={dataSource()}
            pagination={false}
          />
        </Form> */}
        {canEdit ? null : (
          // <div
          //   style={{
          //     display:
          //       recipient?.warehouseReturnStatus ===
          //       WarehouseReturnStatus.Complete
          //         ? ''
          //         : 'none'
          //   }}
          // >
          <CommentTabsComponent
            onSend={onSendComment}
            tabs={tabs}
            commentList={commentList!}
            refectComments={getCommentList}
            itemId={recipient.id}
            commentGroup={CommentGroup.RETURN_DETAIL}
            disabled={disableCommentTab}
          />
          // </div>
        )}
      </Spin>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openRemove}
        textCancel="취소"
        textOk="확인"
        title="삭제 하시겠습니까?"
        action_oke={removeRequest}
        action_cancel={() => setOpenRemove(false)}
      />

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openSave}
        textCancel="취소"
        textOk="확인"
        title="저장 하시겠습니까?"
        action_oke={saveRequest}
        action_cancel={() => setOpenSave(false)}
      />
    </div>
  );
};

export default memo(ReturnDetailOrder);
